// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "../../../../../../node_modules/rescript/lib/es6/curry.js";
import * as React from "react";
import * as GAEvents from "../../../../../library/ga/GAEvents.bs.js";
import * as PartnerScoreConfig from "../../../domain/store/PartnerScoreConfig.bs.js";
import * as PartnerScoreHelper from "../../../domain/helper/PartnerScoreHelper.bs.js";
import * as PartnerScoreAssetConfig from "../../assets/PartnerScoreAssetConfig.bs.js";
import * as PartnerScoreModalManager from "../../modals/PartnerScoreModalManager.bs.js";

function ScoreCardHeader(Props) {
  var title_text = Props.title_text;
  var msisdn = Props.msisdn;
  var info_btn_details = Props.info_btn_details;
  var match = PartnerScoreModalManager.useModal(undefined, undefined);
  var toggle_modal = match[1];
  return React.createElement("div", {
              className: "card-header-container"
            }, match[0], React.createElement("div", {
                  className: "card-title-box"
                }, React.createElement("div", {
                      className: "card-title"
                    }, title_text), React.createElement("button", {
                      className: "card-title-info-btn",
                      onClick: (function (param) {
                          GAEvents.publishEventParameter(PartnerScoreConfig.iBtnClickEventName, PartnerScoreHelper.getButtonClickPayload(msisdn, PartnerScoreConfig.iBtnTitle, PartnerScoreHelper.getCurrentTimestamp(undefined)));
                          return Curry._1(toggle_modal, (function (param) {
                                        return {
                                                TAG: /* ScoreDetails */1,
                                                _0: info_btn_details
                                              };
                                      }));
                        })
                    }, React.createElement("img", {
                          className: "card-title-info-icon",
                          src: PartnerScoreAssetConfig.info_icon
                        }))));
}

var make = ScoreCardHeader;

export {
  make ,
  
}
/* react Not a pure module */
